import playgroundApi from "../playgroundApi";
import {getComputerId, getComputerType} from "../device/deviceInfo";
import {deleteSignInData, getSignInDataFromLocalStorage, saveSignInDataToLocalStorage} from "./sign-in-data";
import {currentSignInDataVersion} from "../../config/config";
import productMonitoring from "../log/productMonitoring";
import {myProfile} from "./my-profile";
import nativeBridge from "../nativeBridge";

interface ISignupDetails {
  email: string,
  password: string
}

class UserAuthentication {

  public async signIn(username: string, password: string){
    const startSessionResponse = await playgroundApi.authentication(
      username,
      password,
      getComputerId(),
      getComputerType()
    );
    const {
      session: {
        token: sessionToken,
        id: sessionId, expiration
      },
      user: {
        id: userId,
        soundsliceUserIdentifier,
      },
    } = startSessionResponse;
    const tokenExpiryDate = new Date(expiration);
    const tokenExpiryTime = tokenExpiryDate.getTime();

    saveSignInDataToLocalStorage({
      sessionId: sessionId.toString(),
      sessionToken,
      userId,
      tokenExpiryTime,
      version: currentSignInDataVersion,
      soundsliceUserIdentifier,
    });

    // Notify native layer that user signed in
    nativeBridge.sendMessageToNative({
      type: "user.signedIn",
      userId: userId
    });

    await myProfile.loadProfile();
  }

  public async signUp({
    email,
    password
  }: ISignupDetails){
    //build request object
    const computerId = getComputerId();
    const computerType = getComputerType();

    // send request
    const result = await playgroundApi.createAccount({
      username: email,
      email,
      password,
      computerId,
      computerType
    });
    const {session: {id: sessionId, token: sessionToken, expiration}, user: {id: userId, soundsliceUserIdentifier,}} = result;
    const tokenExpiryDate = new Date(expiration);
    const tokenExpiryTime = tokenExpiryDate.getTime();
    saveSignInDataToLocalStorage({
      sessionId: sessionId.toString(),
      sessionToken,
      userId,
      tokenExpiryTime,
      version: currentSignInDataVersion,
      soundsliceUserIdentifier,
    });

    // Notify native layer that user signed up
    nativeBridge.sendMessageToNative({
      type: "user.signedUp",
      userId: userId
    });

    void myProfile.loadProfile();
  }

  public signOut(){
    deleteSignInData();
    playgroundApi.deleteUserSession();
    // reset product monitoring session
    productMonitoring.resetSession();

    // Notify native layer that user signed out
    const signInData = getSignInDataFromLocalStorage();
    nativeBridge.sendMessageToNative({
      type: "user.signedOut",
      userId: signInData?.userId ?? 0
    });

    // trigger my profile to trigger reload
    myProfile.triggerReload();
  }
}

export const userAuthentication = new UserAuthentication();
